const bundleBuilder = () => {

  setTimeout(() => {
    const bundleSummary = document.querySelector('.bundle-builder-app--bundle--summary');
    if (bundleSummary) {
      const bundleTitle = document.createElement('h3');
      const titleContent = document.createTextNode('Your Bundle');
    
      bundleTitle.appendChild(titleContent);
      bundleTitle.classList.add('bundle-builder-app--summary--title');
      bundleSummary.appendChild(bundleTitle);
    }
  
  }, 2000)

}
export default bundleBuilder